<template lang="pug">
  v-card
    v-toolbar.elevation-0(height="45" color="gray")
      v-toolbar-title
        h1.subheading {{ $t('labels.pinNumber') }}
      v-spacer
      v-btn(small v-if="checkRightStatus(56)" color='pink' dark icon @click="setupPin")
        v-icon(small) edit
    v-card-text
      h1.display-2.font-weight-light.text-xs-center.red--text(v-if="organization.pinNumber") {{ organization.pinNumber }}
      v-btn(block color="secondary" dark v-else @click="setupPin") Setup Pin Number
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import locationService from '../../service.js'

export default {
  data() {
    return {
      pinNumber: null,
    }
  },
  computed: {
    ...mapGetters('location', ['location', 'organization']),
    ...mapGetters('global', ['currentUser', 'checkRightStatus']),
  },
  methods: {
    setupPin() {
      this.$swal({
        title: 'Pin Number',
        input: 'number',
        showCancelButton: true,
        confirmButtonText: 'Save',
        showLoaderOnConfirm: true,
        inputValidator: (value) => {
          console.log('value test', value)
          console.log('value test', value.length)
          
          if (value.length < 4 || value.length > 4){
            console.log('im in ')
            return 'Pin have to be 4 digits.'
          }
        },
        preConfirm: (pinNumber) => {
          let data = {pinNumber: pinNumber}
          this.pinNumber = pinNumber
          return locationService.setupPin(this.organization.organizationID, data)
          .then(result => {
            return result
          }).catch(err => {
            return err
          })
        },
        allowOutsideClick: () => !this.$swal.isLoading()
        }).then((result) => {
          console.log('then run ', result)
          if (result.value) {
            this.$swal({
              title: `Setup Pin Number`,
              text: `Pin Number was setup successfully.`,
              type: 'success'
            }).then(() => {
              console.log('test pin', this.pinNumber)
              this.setOrgPinNumber(this.pinNumber)
            })
          }
        }).catch(err => {
            this.$swal({
              title: `Setup Pin Number`,
              text: `Can't setup pin number`,
              type: 'error'
            })
            console.log('error in catch', err)
        })
    },
  }
}
</script>

<style scoped>
</style>